import { customEvent } from './utils';

export default element => {
	var Button = function (element) {
		var toggled = false;

		var keyHandler = function (e) {
			var key = e.which || e.keyCode;
			key === 32 && e.target === document.activeElement && toggle(e);
		};

		var preventScroll = function (e) {
			var key = e.which || e.keyCode;
			key === 32 && e.preventDefault();
		};

		var toggle = function (e) {
			var label = e.target.tagName === 'LABEL' ? e.target : e.target.parentNode.tagName === 'LABEL' ? e.target.parentNode : null; // the .btn label
			if (!label) return; // react if a label or its immediate child is clicked

			var eventTarget = e.target; // the button itself, the target of the handler function
			var labels = [].slice.call(eventTarget.parentNode.parentNode.getElementsByClassName('btn'));

			var input = label.getElementsByTagName('INPUT')[0];
			if (!input) return; //return if no input found

			// manage the dom manipulation
			if (input.type === 'checkbox') { //checkboxes
				if (!input.checked) {
					label.classList.add('active');
					input.getAttribute('checked');
					input.setAttribute('checked', 'checked');
					input.checked = true;
				} else {
					label.classList.remove('active');
					input.getAttribute('checked');
					input.removeAttribute('checked');
					input.checked = false;
				}

				if (!toggled) { // prevent triggering the event twice
					toggled = true;

					customEvent.call(input, 'btn', 'show'); //trigger the change for the input
					customEvent.call(element, 'btn', 'show'); //trigger the change for the btn-group
				}
			}

			if (input.type === 'radio' && !toggled) { // radio buttons
				if (!input.checked) { // don't trigger if already active
					label.classList.add('active');
					input.setAttribute('checked', 'checked');
					input.checked = true;
					customEvent.call(input, 'btn', 'change'); // trigger the change for the input
					customEvent.call(element, 'btn', 'change'); // trigger the change for the btn-group

					toggled = true;
					for (var i = 0, ll = labels.length; i < ll; i++) {
						var otherLabel = labels[i];
						var otherInput = otherLabel.getElementsByTagName('INPUT')[0];
						if (otherLabel !== label && otherLabel.classList.contains('active')) {
							otherLabel.classList.remove('active');
							otherInput.removeAttribute('checked');
							otherInput.checked = false;
						}
					}
				}
			}
			setTimeout(function () { toggled = false; }, 50);
		}

		if (!('Button' in element)) { // prevent adding event handlers twice
			element.addEventListener('click', toggle, false);
			element.querySelector('[tabindex]') && element.addEventListener('keyup', keyHandler, false);
			element.addEventListener('keydown', preventScroll, false);
		}

		// activate items on load
		var labelsToActivate = [].slice.call(element.getElementsByClassName('btn'));
		var lbll = labelsToActivate.length;

		for (var i = 0; i < lbll; i++) {
			!labelsToActivate[i].classList.contains('active') && labelsToActivate[i].querySelector('input:checked') && labelsToActivate[i].classList.add('active');
		}
		element.Button = this;
	}

	var elements = element.querySelectorAll('[data-toggle="buttons"]');
	for (var i = 0; i < elements.length; i++) {
		new Button(elements[i]);
	};
};